import React, { useState, useEffect } from 'react';
// import DashboardNav from '../Components/Navigation.js/Navigation'
// import Horheader from '../Components/horheader/horheader'
import classes from './ModuleSelector1.module.css'
import { BsCalculator } from "react-icons/bs";
import { PiScrollLight } from "react-icons/pi";
import { AiOutlineReconciliation } from "react-icons/ai";
import { HiDocumentText } from "react-icons/hi2";
import { IoNewspaperOutline } from "react-icons/io5";
import { RiAdminLine } from "react-icons/ri";
import { AiOutlineAudit } from "react-icons/ai";
import { MdOutlineInventory } from "react-icons/md";
// import pysf from '../Assets/payurfees.png'
// import hostlfees from '../Assets/hostlfees.png'
// import fundurwlt from '../Assets/fundurwlt.png'
// import chekurrslt from '../Assets/chkurwlt.png'
// import gturcrsmtrls from '../Assets/gturcrsmtrls.png'
// import rgstrurcurses from '../Assets/rgstrurcurses.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
// import firstImg from '../Assets/dashboardfirst.svg'
// import T_Icon from '../Assets/T Icon.svg'
// import M_Icon from '../Assets/M_Icom.svg'
// import Q_Icon from '../Assets/QIcon.svg'
// import TheImg from '../Assets/BottomIcon.svg'
// import bell from '../Assets/notification.png'
// import avatar from '../Assets/avatar.png'
import RotatingLogo from '../../Assets/rotating-logo.png';
import icon7 from '../../Assets/logoutt.png';

import { ProgressBar, Spinner, Button, Modal, Form, Card, Row, Col, Badge } from 'react-bootstrap';

import axios from 'axios';
// import AsyncStorage from '@react-native-async-storage/async-storage';

import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import ToggleSlider from './ToggleSlider';
import CurrencyInput from 'react-currency-input-field';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Select from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaCalendarAlt } from 'react-icons/fa';
import { BASE_URL } from '../../Components/Styles/API/API';




const ModuleSelector1 = () => {
  const [loanCode, setLoanCode] = useState('');
  const [interest, setInterest] = useState('');
  const [loanDescription, setLoanDescription] = useState('');
  const [balance, setBalance] = useState('');
  const [selectedReport, setSelectedReport] = useState('');
  const [selectedPayables, setSelectedPayables] = useState(null);
  const [stat, setStat] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [subCat, setSubcat] = useState([]);
  const [subCatProcess, setSubcatProcess] = useState([]);
  const [subCat2, setSubcat2] = useState([]);
  const [fixedDate, setFixedDate] = useState('');
  const [cashbookOpening, setCashbookOpening] = useState('');
  const [statementOpening, setStatementOpening] = useState('');
  const [fixedDate2, setFixedDate2] = useState('');
  const [recievables, setReceivables] = useState([]);
  const [newLoading, setNewLoading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState('');
  const [selectedAccount2, setSelectedAccount2] = useState('');
  const [selectedAccountProcess, setSelectedAccountProcess] = useState('');
  const [selectedAccountName, setSelectedAccountName] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedDates, setSelectedDates] = useState('');
  const [selectedDate2, setSelectedDate2] = useState('');
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedImage2, setSelectedImage2] = useState('');
  const [cashBalance, setCashBalance] = useState('');
  const [statementBalance, setStatementBalance] = useState('');
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [balances, setBalances] = useState([]);
  const [balances2, setBalances2] = useState([]);
  const [balanceProcess, setBalanceProcess] = useState([]);





  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show2Process, setShow2Process] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show6Process, setShow6Process] = useState(false);
  const [show7, setShow7] = useState(false);
  const [show8, setShow8] = useState(false);
  const handleClose = () => {
    clearForm();
    setShow(false);
  }
  const handleClose2 = () => setShow2(false);
  const handleClose2Process = () => setShow2Process(false);
  const handleClose4 = () => setShow4(false);
  const handleClose5 = () => setShow5(false);
  const handleClose6 = () => setShow6(false);
  const handleClose6Process = () => setShow6Process(false);
  const handleClose7 = () => setShow7(false);
  const handleClose8 = () => setShow8(false);

  const handleValueChange = (value, name, values) => {
    setBalance(value);

  };

  const handleClose3 = () => {
    clearForm();
    setShow3(false);
  }
  const handleClose1 = () => {
    setToggleStates({});
    setShow1(false);
  }

  const handleAccountChange = (selectedOption) => {
    setSelectedAccount(selectedOption.value);
  };

  const handleAccountChangeProcess = (selectedOption) => {
    setSelectedAccountProcess(selectedOption.value);
    setSelectedAccountName(selectedOption.label);
    setFixedDate2(selectedOption.fixeddate);
    setFixedDate(selectedOption.fixeddateState);
    setSelectedDate(selectedOption.fixeddate);
    setCashbookOpening(selectedOption.cashbookOpeningBalance);
    setStatementOpening(selectedOption.statementOpeningBalance);
  };

  function formatDateToLastOfMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth();

    // Get last day of the month
    const lastDay = new Date(year, month + 1, 0);

    // Format day with suffix (st, nd, rd, th)
    const day = lastDay.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    // Format month name
    const monthName = lastDay.toLocaleString("default", { month: "long" });

    return `${day}${suffix} ${monthName}, ${year}`;
  }

  function formatCurrency(value) {
    if (value === null || value === undefined || value === "") return "";
    // Ensure it's treated as a number
    const num = parseFloat(value);
    return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  const handleAccountChange2 = (selectedOption) => {
    setSelectedAccount2(selectedOption.value);
    setSelectedAccountId(selectedOption?.value);
    setFixedDate(selectedOption.fixeddate);
    setSelectedDate("");
  };

  const handlePeriodChange = (selectedOption) => {
    setSelectedPeriod(selectedOption.value);
  };


  const handleShow = () => setShow(true);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => {
    setShow6(false);
    setShow5(false);
    setShow2(true);
  };
  const handleShow2Process = () => {
    setShow6Process(false);
    setShow5(false);
    setShow2Process(true);
  };
  const handleShow3 = () => setShow3(true);
  const handleShow7 = () => {
    setShow7(true);
    setShow4(false);
  };
  const handleShow8 = () => {
    setShow4(false);
    setShow8(true);
  };
  const handleShow4 = () => {
    setShow4(true);
    setShow5(false);
    setShow7(false);
    setShow8(false);
  };
  const handleShow5 = () => {
    setShow2(false); // Close the other modal
    setShow4(false); // Close the other modal
    setShow5(true);  // Open this modal
  };

  const handleShow5Process = () => {
    setShow2Process(false); // Close the other modal
    setShow4(false); // Close the other modal
    setShow8(true);  // Open this modal
  };

  const handleShow6 = () => {
    setShow2(false);
    setShow6(true);
  };

  const handleShow6Process = () => {
    setShow2Process(false);
    setShow6Process(true);
  };
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [company, setCompany] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loanLoading, setLoanLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [createLoading2, setCreateLoading2] = useState(false);
  const [contLoading, setContLoading] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subContloading, setSubContLoading] = useState(false);
  const [subRegloading, setSubRegLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [eyeClicked, setEyeClicked] = useState(false);
  const [staffLoading, setStaffLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [accPay, setAccPay] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [searchedResult, setSearchedResult] = useState([]);
  const [trashClicked, setTrashClicked] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [admin, setAdmin] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedRegion1, setSelectedRegion1] = useState("");
  const [selectedContinent, setSelectedContinent] = useState("");
  const [selectedContinent1, setSelectedContinent1] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedProvince1, setSelectedProvince1] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [accRec, setAccRec] = useState([]);
  const [continents, setContinents] = useState([]);
  const [staffLoan, setStaffLoan] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [selectedId, setSelectedId] = useState('');
  const [validity, setValidity] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [moduleLoading, setModuleLoading] = useState(false);
  const [permId, setPermId] = useState([]);
  const [userType, setUserType] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [trashClicked1, setTrashClicked1] = useState(false);
  const [trashClicked2, setTrashClicked2] = useState(false);
  const [permits, setPermits] = useState([]);
  const [error, setError] = useState(null);
  const [continent, setContinent] = useState('');
  const [selectedLoan, setSelectedLoan] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [monthLoading, setMonthLoading] = useState(false);
  const [provinceID, setProvinceID] = useState('');
  const [totalDebitCount, setTotalDebitCount] = useState('');
  const [totalCreditCount, setTotalCreditCount] = useState('');
  const [totalDebitCount2, setTotalDebitCount2] = useState('');
  const [totalCreditCount2, setTotalCreditCount2] = useState('');
  const [totalAmountDebit, setTotalAmountDebit] = useState('');
  const [totalAmountCredit, setTotalAmountCredit] = useState('');
  const [totalAmountDebit2, setTotalAmountDebit2] = useState('');
  const [totalAmountCredit2, setTotalAmountCredit2] = useState('');
  const [closingBalance, setClosingBalance] = useState('');
  const [closingBalance2, setClosingBalance2] = useState('');
  const [userId, setUserId] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [toggleStates, setToggleStates] = useState({});
  const [rows1, setRows1] = useState([{ id: Date.now(), postDate: "", valDate: "", description: "", debit: "", credit: "" }]);

  const [currentPage2, setCurrentPage2] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
// console.log(userId, typeof userId, "USERIDDDDDDDDDDDDDDDDDDDDDDDDDD");
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value12 = await localStorage.getItem('tobiID');
      // const value2 = await localStorage.getItem('permissions');
      const value3 = await localStorage.getItem('admin');
      const value7 = await localStorage.getItem('companyName');
      const value8 = await localStorage.getItem('validity');
      const permitsss = await localStorage.getItem('permissions');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const current = await localStorage.getItem('currentMonth');
      const provinceId = await localStorage.getItem('provinceID');


      if (value !== null) {
        setBearer(value);
      }
      if (permitsss !== null) {
        const parsedPermits = JSON.parse(permitsss);
        const permitNames = parsedPermits.map(permit => permit.name);
        setPermits(permitNames);
        // console.log(permitNames);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value12 !== null) {
        setUserId(value12);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }

      if (value8 !== null) {
        setValidity(value8);
      }
      if (current !== null) {
        setCurrentMonth(new Date(current));
      }
      if (provinceId !== null) {
        setProvinceID(provinceId);
      }

      // if (value2 !== null) {
      //   setPermissions(value2);
      // }
      if (value3 !== null) {
        setAdmin(value3);
      }
      if (value7 !== null) {
        setCompany(value7);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const handleAddRow1 = () => {
    setRows1([...rows1, { id: Date.now(), postDate: "", valDate: "", description: "", debit: "", credit: "" }]);
  };

  const handleRemoveRow1 = index => {
    setRows1(rows1.filter((_, i) => i !== index));
  };

  const handleChange1 = (id, field, value) => {
    setRows1(prevRows =>
      prevRows.map(row => (row.id === id ? { ...row, [field]: value } : row))
    );
  };


  const fetchSubCat = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/reconciliation/unset-accounts`,
        {

          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const results = response.data?.data;
      setSubcat(results);


      //   console.log(results, "NIYIN");
    } catch (error) {
      const errorStatus = error?.response?.data?.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCatProcess = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/reconciliation/set-accounts`,
        {

          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const results = response.data?.data;
      setSubcatProcess(results);


      //   console.log(results, "NIYIN");
    } catch (error) {
      const errorStatus = error?.response?.data?.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCat2 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/reconciliation/set-accounts`,
        {

          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const results = response.data?.data;
      setSubcat2(results);


      //   console.log(results, "NIYIN");
    } catch (error) {
      const errorStatus = error?.response?.data?.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const opt = subCat.map((item) => ({
    label: item.gl_name,
    value: item.id,
  }));

  const optProcess = subCatProcess.map((item) => ({
    label: item.gl_name,
    value: item.id,
    fixeddate: item.setup?.cashbook_last_date,
    fixeddateState: item.setup?.smt_last_date,
    cashbookOpeningBalance: item.setup?.cashbook_opening_balance,
    statementOpeningBalance: item.setup?.statement_opening_balance,
  }));

  const opt2 = subCat2.map((item) => ({
    label: item.gl_name,
    value: item.id,
    fixeddate: item.setup?.smt_last_date,
  }));




  const fetchData = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/users/fetch-all?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results);
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData([]);
      }
    } finally {
      setRoleLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchData();
      fetchSubCat();
      fetchSubCat2();
      fetchSubCatProcess();
    }
  }, [bearer]);


  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleImageChange2 = (event) => {
    const file = event.target.files[0];
    setSelectedImage2(file);
  };

  //   const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSelectedImage(file); // if you're storing the file
  //     uploadStatement3(file); // only trigger if a file is selected
  //   }
  // };

  const fetchSearch = async (searchTerm) => {
    setSearchLoading(true);
    try {
      let res;
      if (searchTerm.trim() === "") {
        res = tableData1;
      } else {
        const response = await axios.get(`${BASE_URL}/users/search`, {
          params: { variable: searchTerm },
          headers
        });
        res = response.data?.data;
      }
      setSearchedResult(res);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setSearchedResult([]);
      }
    } finally {
      setSearchLoading(false);
    }
  };

  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      console.log("lists:", typeList);
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStaffLoan = async () => {
    setStaffLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const staffs = response.data?.data;
      console.log("lists:", response);
      setStaffLoan(staffs);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setStaffLoan([]);
      }
    } finally {
      setStaffLoading(false);
    }
  };

  const fetchAcReceivables = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/receivables`, { headers });
      const accs = response.data?.data;
      console.log("lists:", response);
      const accOptions = accs.map(item => ({
        label: item.gl_name,
        value: item.id
      }));

      setAccRec(accOptions);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setAccRec([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAcPayables = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
      const pay = response.data?.data;
      console.log("lists:", response);
      const payOptions = pay.map(item => ({
        label: item.gl_name,
        value: item.id
      }));

      setAccPay(payOptions);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setAccPay([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };


  const createLoan = async () => {

    setLoanLoading(true);
    try {

      const response = await axios.post(`${BASE_URL}/account/create-loan-account`,
        {
          code: loanCode,
          description: loanDescription,
          opening_balance: balance,
          report_to: selectedReportTo?.value,
          payable: selectedPayables?.value,
          interest: interest,
          type: 2

        },
        { headers }
      );
      console.log(response.data.message)
      fetchStaffLoan();
      setLoanCode('');
      setLoanDescription('');
      setBalance('');
      setSelectedReportTo(null);
      setSelectedPayables(null);
      setInterest('');

      // return
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setLoanLoading(false);
    }
  }

  const uploadStatement3 = async (file) => {
    setCreateLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bank_id', selectedAccount);
      formData.append('date', selectedDate);
      const response = await axios.post(
        `${BASE_URL}/reconciliation/upload_cash_statement`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances(response.data.data);
      // handleClose();
      // handleShow2(true);
      // Reset form fields
      // setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      //   setTimeout(() => {
      //   setCreateLoading(false);
      // }, 4000);
      setCreateLoading(false);
    }
  };

  const uploadStatement4 = async (file) => {
    setCreateLoading2(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bank_id', selectedAccount);
      formData.append('date', selectedDate2);
      const response = await axios.post(
        // `${BASE_URL}/reconciliation/upload_cash_statement`,
        `${BASE_URL}/reconciliation/bank_statement_setup`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances2(response.data.data);
      // handleClose();
      // handleShow2(true);
      // Reset form fields
      // setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      //         setTimeout(() => {
      //   setCreateLoading2(false);
      // }, 4000);
      setCreateLoading2(false);
    }
  };

  const uploadStatement4Process = async (file) => {
    setCreateLoading2(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bank_id', selectedAccountProcess);
      // formData.append('date', selectedDate2);
      const response = await axios.post(
        // `${BASE_URL}/reconciliation/upload_cash_statement`,
        `${BASE_URL}/reconciliation/continual_bank_statement_setup`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances2(response.data.data);
      // handleClose();
      // handleShow2(true);
      // Reset form fields
      // setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      //         setTimeout(() => {
      //   setCreateLoading2(false);
      // }, 4000);
      setCreateLoading2(false);
    }
  };

  const pullCashbook = async () => {
    setCreateLoading2(true);
    try {
      const formData = new FormData();
      formData.append('bank_id', selectedAccountProcess);
      const response = await axios.post(
        // `${BASE_URL}/reconciliation/upload_cash_statement`,
        `${BASE_URL}/reconciliation/get-all-month-cashbook`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalanceProcess(response.data.data);
      await localStorage.setItem('balanceProcess', JSON.stringify(response.data.data));
      await localStorage.setItem('bankID', selectedAccountProcess);
      await localStorage.setItem('bankName', selectedAccountName);
      await localStorage.setItem('cashbookDate', fixedDate2);
      await localStorage.setItem('statementDate', fixedDate);
      await localStorage.setItem('cashbookAccountOpening', cashbookOpening);
      await localStorage.setItem('statementAccountOpening', statementOpening);
      // handleClose();
      navigate('/reconciliation');
      // handleShow2Process(true);
      // Reset form fields
      // setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      //         setTimeout(() => {
      //   setCreateLoading2(false);
      // }, 4000);
      setCreateLoading2(false);
    }
  };

  const calculateTotalDebit = () => {
    const total = balances.reduce((acc, item) => {
      return item.debit ? acc + parseFloat(item.debit || 0) : acc;
    }, 0);

    const formattedTotal1 = total.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountDebit(formattedTotal1);
  };

  const calculateTotalDebit2 = () => {
    const total = balances2.reduce((acc, item) => {
      return item.debit ? acc + parseFloat(item.debit || 0) : acc;
    }, 0);

    const formattedTotal1 = total.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    console.log(formattedTotal1, "debitTotal2");


    setTotalAmountDebit2(formattedTotal1);
  };

  const calculateTotalCredit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.credit ? acc + parseFloat(item.credit || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountCredit(formattedTotal11);
  };

  const calculateTotalCredit2 = () => {
    const total1 = balances2.reduce((acc, item) => {
      return item.credit ? acc + parseFloat(item.credit || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    console.log(formattedTotal11, "creditTotal2");

    setTotalAmountCredit2(formattedTotal11);
  };

  const calculateClosingBalance = () => {
    const credit = parseFloat(totalAmountCredit.replace(/,/g, '')) || 0;
    const debit = parseFloat(totalAmountDebit.replace(/,/g, '')) || 0;
    const statement = parseFloat(cashBalance) || 0;
    const closing = statement + debit - credit;
    const formattedTotal1 = closing.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setClosingBalance(formattedTotal1);
  };

  const calculateClosingBalance2 = () => {
    const credit = parseFloat(totalAmountCredit2.replace(/,/g, '')) || 0;
    const debit = parseFloat(totalAmountDebit2.replace(/,/g, '')) || 0;
    const statement = parseFloat(statementBalance) || 0;
    const closing = statement + credit - debit;
    const formattedTotal1 = closing.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    console.log(formattedTotal1, "closingbalanccce");

    setClosingBalance2(formattedTotal1);
  };

  const calculateDebitCount = () => {
    const count = balances.filter(item => parseFloat(item.debit) > 0).length;
    setTotalDebitCount(count);
  };

  const calculateCreditCount = () => {
    const count = balances.filter(item => parseFloat(item.credit) > 0).length;
    setTotalCreditCount(count);
  };

  const calculateDebitCount2 = () => {
    const count = balances2.filter(item => parseFloat(item.debit) > 0).length;
    console.log(count, "debitcount2");
    setTotalDebitCount2(count);
  };

  const calculateCreditCount2 = () => {
    const count = balances2.filter(item => parseFloat(item.credit) > 0).length;
    console.log(count, "creditcount2");
    setTotalCreditCount2(count);
  };

  useEffect(() => {
    calculateTotalDebit();
    calculateTotalCredit();
    calculateDebitCount();
    calculateCreditCount();
    // calculateClosingBalance();
  }, [balances]);

  useEffect(() => {
    calculateTotalDebit2();
    calculateTotalCredit2();
    calculateDebitCount2();
    calculateCreditCount2();
    // calculateClosingBalance2();

  }, [balances2]);

  useEffect(() => {
    if (totalAmountCredit && totalAmountDebit && cashBalance !== null) {
      calculateClosingBalance();
    }
  }, [totalAmountCredit, totalAmountDebit, cashBalance]);

  useEffect(() => {
    if (totalAmountCredit2 && totalAmountDebit2 && statementBalance !== null) {
      calculateClosingBalance2();
    }
  }, [totalAmountCredit2, totalAmountDebit2, statementBalance]);


  const postBalances2 = async () => {
    setBalanceLoading(true);
    try {
      //  return;
      const response = await axios.post(
        // `${BASE_URL}/payment_voucher/save-bank-statement`,
        `${BASE_URL}/reconciliation/set-up-account-for-reconciliation`,
        {
          total_debit: totalAmountDebit,
          total_credit: totalAmountCredit,
          cashbook_uuid: balances[0]?.uuid,
          statement_uuid: balances2[0]?.uuid,
          cashbook_date: selectedDate,
          statement_date: selectedDate2,
          statement_balance: statementBalance,
          cashbook_balance: cashBalance,
          account_id: selectedAccount,
        },
        { headers }
      );
      console.log(response.data?.message, "heeee");

      handleClose6('');
      setBalances([]);
      setBalances2([]);
      setTotalAmountCredit('');
      setTotalAmountCredit2('');
      setTotalAmountDebit2('');
      setSelectedDate('');
      setSelectedDate2('');
      setStatementBalance('');
      setCashBalance('');
      setSelectedAccount('');
      fetchSubCat2();
      fetchSubCat();
      fetchSubCatProcess();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };

  const postBalances2Process = async () => {
    setBalanceLoading(true);
    try {
      //  return;
      const response = await axios.post(
        // `${BASE_URL}/payment_voucher/save-bank-statement`,
        `${BASE_URL}/reconciliation/continual-account-setup-for-reconciliation`,
        {
          // total_debit: totalAmountDebit,
          // total_credit: totalAmountCredit,
          // cashbook_uuid: balances[0]?.uuid,        
          statement_uuid: balances2[0]?.uuid,
          // cashbook_date: selectedDate,        
          // statement_date: selectedDate2,        
          // statement_balance: statementBalance,        
          // cashbook_balance: cashBalance,        
          account_id: selectedAccountProcess,
        },
        { headers }
      );
      console.log(response.data?.message, "heeee");

      handleClose6Process('');
      setBalances([]);
      setBalances2([]);
      setTotalAmountCredit('');
      setTotalAmountCredit2('');
      setTotalAmountDebit2('');
      setSelectedDate('');
      setSelectedDate2('');
      setStatementBalance('');
      setCashBalance('');
      setSelectedAccount('');
      fetchSubCat2();
      fetchSubCat();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };

  //filter function
  const filteredData = tableData.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
  const displayedData = filteredData.slice(currentPage - 1, totalEntries);

  console.log(permits);

  // const indexOfLastRow = currentPage2 * rowsPerPage;
  // const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  // const currentRows = (balances || balanceProcess).slice(indexOfFirstRow, indexOfLastRow)
  // const totalPages2 = Math.ceil(balances.length / rowsPerPage);

  const indexOfLastRow = currentPage2 * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const dataSource = balances && balances.length > 0 ? balances : balanceProcess;
  const currentRows = dataSource.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages2 = Math.ceil(dataSource.length / rowsPerPage);

  const handleModuleClick = (module) => {
    if (permits.includes(module)) {
      setError(null);
      if (module === 'Final Accounts') {
        navigate('/accounting');
      }
      if (module === 'Cash Management') {
        navigate('/cash_management');
      }
      if (module === 'Administration') {
        navigate('/admin');
      }
      if (module === 'audit') {
        navigate('/admin');
      }
      // if (module === 'Reconciliation') {
      //   navigate('/reconciliation');
      // }
      if (module === 'Payments') {
        navigate('/payment');
      }
      if (module === 'Account Receivables') {
        navigate('/receivables');
      }
      if (module === 'Account Payables') {
        navigate('/payables');
      }
      if (module === 'Journal Entries') {
        navigate('/journals');
      }
      if (module === 'cooperative_management_system') {
        navigate('/cooperative');
      }
      if (module === 'event_centers_mgt_system') {
        navigate('/event_mgt_system');
      }
      if (module === 'inventory') {
        // navigate('/inventory');
        return;
      }
      if (module === 'Fixed Assets') {
        if (['Provincial Accountant', 'Regional Accountant','Compliance', 'Continental Accountant'].includes(admin)) {
          navigate('/fixed_asset_home');
        } 
        else if (admin === 'Super Admin') {
          navigate('/fixed_asset_admin_home');
        }

      }

      // if (module === 'Budgets') {
      //   window.open('https://pentsuite.com.ng/budget', '_blank');
      // }
      // if (module === 'Fixed Assets') {
      //   navigate('/fixed_asset_home');
      // }
      if (module === 'Budgets') {
        navigate('/admin');
      }
      // if (module === 'Reconciliation') {
      //   window.open('https://pentsuite.com.ng/', '_blank');
      // }

    } else {
      setError(`Access to ${module} is forbidden`);
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: `Access to ${module} is forbidden`,
      });

    }
  };

  const getOrdinalSuffix = (number) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = number % 100;
    return v >= 11 && v <= 13 ? 'th' : suffixes[v % 10] || 'th';
  };

  const formattDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      return 'Invalid Date';
    }

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
  };

  // const currentMonth = new Date();

  const handleLogout = async () => {
    setLogoutLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/logout`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      navigate('/login');
      //   toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response) {
        if (error.response.status === 401) {
          navigate('/login');
        } else if (error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
      }
      //   toast.error(errorMessage);
      console.log(error);
    } finally {
      setLogoutLoading(false);
    }
  };

  const editUser = async (id) => {
    setCreateLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/users/update-user`,
        {
          name: fullName,
          email: email,
          phone_number: phone,
          user_id: selectedUser,
        },
        { headers }
      );

      fetchData();
      setFullName('');
      setPhone('');
      setEmail('');
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      // console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.data),
        });
        console.log(error);
      }
    } finally {
      setCreateLoading(false);
    }
  };



  const handleEyeClick = (id) => {
    const foundUser = tableData.find(item => item.id === id);

    if (foundUser) {
      const { name, email, phone_number } = foundUser;
      setSelectedUser(id);
      setFullName(name || '');
      setEmail(email || '');
      setPhone(phone_number || '');

      setIsUpdateMode(true);

    } else {
      console.error(`User with id ${id} not found`);
    }
  };

  const handleEyeClick1 = (id) => {
    const foundLoan = staffLoan.find(item => item.id === id);

    if (foundLoan && foundLoan) {
      const slcRpt = accRec.find(item => item.value === foundLoan.report.id);
      setSelectedReportTo(slcRpt);
    }

    if (foundLoan && foundLoan) {
      const slcPay = accPay.find(item => item.value === foundLoan.report.id);
      setSelectedPayables(slcPay);
    }

    if (foundLoan) {
      const { code, description, interest, opening_balance, } = foundLoan;
      setSelectedLoan(id);
      setLoanCode(code || '');
      setLoanDescription(description || '');
      setInterest(interest || '');
      setBalance(opening_balance || '');


      setIsUpdateMode(true);

    } else {
      console.error(`User with id ${id} not found`);
    }
  };



  const clearForm = () => {
    setSelectedUser(null);
    setSelectedLoan(null);
    setSelectedReportTo(null);
    setFullName('');
    setPhone('');
    setEmail('');
    setLoanDescription('');
    setLoanCode('');
    setBalance('');
    setInterest('');
    setIsUpdateMode(false);
  };


  const handleTrashClick = async (id) => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this user.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    try {
      const response = await axios.get(`${BASE_URL}/users/delete?id=${id}`, { headers });
      fetchData();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(errorMessage);
      }
    }
  };


  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
  };

  const createUser = async () => {
    setCreateLoading(true);
    try {
      console.log(fullName, email, phone);
      const response = await axios.post(
        `${BASE_URL}/users/create-new`,
        {
          name: fullName,
          email: email,
          phone_number: phone,

        },
        { headers }
      );
      console.log(response)
      fetchData();
      setFullName('');
      setPhone('');
      setEmail('');

      // return
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setCreateLoading(false);
    }
  };

  const editLoan = async () => {

    setLoanLoading(true);
    try {

      const response = await axios.post(`${BASE_URL}/account/update-account`,
        {
          code: loanCode,
          description: loanDescription,
          opening_balance: balance,
          report_to: selectedReportTo?.value || '',
          payable: selectedPayables?.value || '',
          type: 2,
          id: selectedLoan

        },
        { headers }
      );
      console.log(response.data.message)

      clearForm();
      fetchStaffLoan();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      // return
      console.log(response.data);

    } catch (error) {

      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: error.response.data.message,
        });
        console.log(errorMessage);
      }
    } finally {
      setLoanLoading(false);
    }
  };

  const handleSubmit = () => {
    if (isUpdateMode) {
      // Call update user function here
      editUser();
    } else {
      // Call create user function here
      createUser();
    }
  };

  const handleSubmit1 = () => {
    if (isUpdateMode) {
      // Call update user function here
      editLoan();
    } else {
      // Call create user function here
      createLoan();
    }
  };

  const fetchPermission = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/users/fetch-user-modules`, { headers });
      const data = response?.data?.data;
      const permissionId = data?.map(item => item.id);
      setPermId(permissionId);
      console.log(data);
      const initialToggleStates = Object.fromEntries(permissions.map(id => [id, false]));

      // const initialToggleStates = false; 


      setPermissions(data);
      setToggleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(error);
      setPermissions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchPermission();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer) {
      fetchAcReceivables();
      fetchAcPayables();
      fetchStaffLoan();
    }
  }, [bearer]);



  const handleToggleChange = (itemId) => {
    setToggleStates(prevToggleStates => ({
      ...prevToggleStates,
      [itemId]: !prevToggleStates[itemId],
    }));
  };

  const handleCheckAllToggle = () => {
    const checkAllValue = !checkAll;
    setCheckAll(checkAllValue);

    // Set all toggle states to the determined value
    const updatedToggleStates = Object.fromEntries(permId.map(id => [id, checkAllValue]));
    setToggleStates(updatedToggleStates);
  };



  const createModule = async () => {
    setModuleLoading(true);

    try {
      // Map IDs to names
      const idToNameMap = permissions.reduce((acc, item) => {
        acc[item.id] = item.id;
        return acc;
      }, {});

      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.module?.id);

      // const selectedToggle = Object.entries(toggleStates)
      //   .filter(([_, value]) => value)
      //   .map(([key, _]) => idToNameMap[parseInt(key)]);

      console.log(selectedUser, selectedToggle);
      // return;

      const response = await axios.post(
        `${BASE_URL}/users/assign-module`,
        {
          user_id: selectedUser,
          module: selectedToggle
        },
        { headers }
      );

      handleClose1();
      setToggleStates({});
      setSelectedUser('');
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      // handleLogout();
      //   toast.success(response.data.message)

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.data)
        });
        console.log(error);
      }

    } finally {
      setModuleLoading(false);
    }
  };

  const getNextMonthName = (currentMonth) => {
    // Parse the currentMonth string to create a Date object
    const date = new Date(currentMonth);

    // Extract the current month (0-based index, so adding 1 to get the next month)
    let nextMonth = date.getMonth() + 1; // getMonth() is 0-based (Jan = 0)

    // If the next month is December (11) and we need to roll over to January
    if (nextMonth > 11) {
      nextMonth = 0;
    }

    // Create a new date object for the next month (day set to 1 for simplicity)
    const nextMonthDate = new Date(date.getFullYear(), nextMonth, 1);

    // Use toLocaleString() to get the month name in words
    const nextMonthName = nextMonthDate.toLocaleString('default', { month: 'long' });

    return nextMonthName;
  };

  const getPrevMonthName = (currentMonth) => {
    // Parse the currentMonth string to create a Date object
    const date = new Date(currentMonth);

    // Extract the current month and subtract 1 to get the previous month
    let prevMonth = date.getMonth() - 1; // getMonth() is 0-based (Jan = 0)

    // If the previous month is before January, roll over to December of the previous year
    if (prevMonth < 0) {
      prevMonth = 11; // December
      date.setFullYear(date.getFullYear() - 1); // Move to the previous year
    }

    // Create a new date object for the previous month (day set to 1 for simplicity)
    const prevMonthDate = new Date(date.getFullYear(), prevMonth, 1);

    // Use toLocaleString() to get the month name in words
    const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'long' });

    return prevMonthName;
  };

  const getCurrentMonthName = (currentMonth) => {
    // Parse the currentMonth string to create a Date object
    const date = new Date(currentMonth);

    // Use toLocaleString() to get the current month name in words
    const currentMonthName = date.toLocaleString('default', { month: 'long' });

    return currentMonthName;
  };


  const handleTrashClick1 = async () => {
    const currentMonthName = getCurrentMonthName(currentMonth);
    const nextMonthName = getNextMonthName(currentMonth);
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to change your working month from ${currentMonthName} to ${nextMonthName}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Change it!',
      cancelButtonText: 'No, Cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
    Swal.fire({
      title: 'Changing the working month...',
      text: 'Please wait while we process your request.',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      }
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/update-province-month`,
        {}, // Empty body
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      // Close the loading Swal and show the success message
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      navigate('/login');
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Close the loading Swal and show the error message
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false); // Stop loading
    }
  };

  const handleTrashClick2 = async () => {
    const currentMonthName = getCurrentMonthName(currentMonth);
    const prevMonthName = getPrevMonthName(currentMonth);
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to reset your working month from ${currentMonthName} to ${prevMonthName}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Reset it!',
      cancelButtonText: 'No, Cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
    Swal.fire({
      title: 'Resetting the working month...',
      text: 'Please wait while we process your request.',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      }
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/reverse-province-month`,
        {}, // Empty body
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      navigate('/login');
      //   setTrashClicked1(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false); // Stop loading
    }
  };

  const fetchData8 = async () => {
    setNewLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/payable-receivable-dashboard`, { headers });
      const sta = response.data?.data;
      const sta1 = response.data?.data?.top_customers;
      const sta2 = response.data?.data?.account_receivables;
      console.log(sta);
      setStat(sta);
      setCustomer(sta1);
      setReceivables(sta2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setStat([]);
      }
    } finally {
      setNewLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchData8();

    }
  }, [bearer]);


  const uploadStatement2 = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/reconciliation/get-cashbook-account-balance-by-date`,
        {
          account_id: selectedAccount,
          date: selectedDate
        },
        { headers }
      );
      console.log(response, "heeee");
      setCashBalance(response.data.data);
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      // // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const handleReconcilePage2 = () => {
    if (!selectedAccountId || !selectedDate) {
      Swal.fire({
        title: 'Missing field',
        text: 'Please select both account and date.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    localStorage.setItem("selected_account_id", selectedAccountId);
    localStorage.setItem("selected_date", selectedDate);

    const width = 1200;
    const height = 800;

    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);

    window.open(
      '/accounting/bank_reconciliationnew',
      '_blank',
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );

  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} `;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }


  const ModuleCard = ({ moduleName, description, icon, color, assigned, onClick }) => {
    return (
      <div
        className={`${classes.moduleCard} ${assigned ? classes.assigned : classes.notAssigned}`}
        onClick={assigned ? onClick : null}
        style={{ borderColor: '#eeebebff', cursor: assigned ? 'pointer' : 'not-allowed' }}
      >
        <div className={classes.iconBox} style={{ backgroundColor: assigned ? color : '#f0f0f0' }}>
          {icon}
        </div>
        <div className={classes.textBox}>
          <h3>{moduleName}</h3>
          <p>{description}</p>
          {!assigned && <span ><Badge bg='danger' color='white' style={{ padding: 5, borderRadius: 99 }}>Not Assigned</Badge></span>}
        </div>
      </div>
    );
  };

  const getMonthDays = (year, month) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const startDay = new Date(year, month, 1).getDay(); // 0 = Sunday
    const days = [];

    for (let i = 0; i < startDay; i++) {
      days.push(null); // filler for empty days before month starts
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }

    return days;
  };

  const handleDateSelected = (e) => {
    setSelectedDates(e.target.value);
  }
  useEffect(() => {
    if (selectedDates) {
      uploadStatement2();
    }
  }, [selectedDates]);


  return (
    <div>
      {/* <div className={classes.navbrd}> */}
      <ToastContainer />
      <div className={classes.horinfodashbrd}>
        <div className={classes.stinfo}>
          {/* <img src={RCCGLogo} alt="rccg-logo" className={classes.rccgLogo} /> */}
          <div className={classes.wlcmTxt}>
            <p className={classes.stinfosts}>Welcome</p>
            <p className={classes.stinfolvl}>{user.toLocaleUpperCase()}</p>
            <p className={classes.stinfosts}>{`(${admin})`}</p>
          </div>
        </div>

        <div className={classes.usrcnr}>

          {/* <div className={classes.vrtlne}></div> */}
          <div className={classes.usrinfo}>
            <div className={classes.usrnminf}>

              {/* <p className={classes.usrpstn}>Welcome</p> */}
              <p className={classes.usrpstn}>Company Name</p>
              <p className={classes.usrnme}>{province === 'undefined' ? admin : province}</p>
              <p className={classes.usrpstn}>
                {continent !== 'undefined' && continent}
                {continent !== 'undefined' && region !== 'undefined' && ' | '}
                {region !== 'undefined' && region}
              </p>


            </div>
            <div className={classes.avtrs} onClick={() => handleLogout()} >

              <>

                {logoutLoading ? <Spinner size="sm" animation="border" variant="light" /> :
                  <img src={icon7} alt="Icon" className={classes.avtrs} style={{ backgroundColor: '#100561' }} />
                }
              </>
            </div>

          </div>
          {/* <img src={bell} className={classes.bel} /> */}
        </div>

      </div>
      {/* </div> */}

      <div className={classes.appcontainer}>


        <div className={classes.maincontent}>

          <div className={classes.dashBoardCont}>
            <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Manage User</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form style={{ marginBottom: 20 }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Full Name"
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Phone Number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div>
                    <Form.Group className="mb-1">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </div>


                </Form>
                <Modal.Footer>

                  {isUpdateMode && (
                    <Button variant="danger" onClick={clearForm}>
                      Clear Form
                    </Button>
                  )}
                  <Button variant="success" onClick={handleSubmit}>
                    {createLoading ? (
                      <>
                        <Spinner size='sm' />
                        <span style={{ marginLeft: '5px' }}>{isUpdateMode ? "Updating user, Please wait..." : "Creating user, Please wait..."}</span>
                      </>
                    ) : (
                      isUpdateMode ? 'Update User' : 'Create User')}
                  </Button>

                </Modal.Footer>


                <div className="d-flex justify-content-between align-items-center" style={{ padding: '20px 0 0 0', marginBottom: 20 }}>

                </div>

                <div className={classes.spaceb} />
                <div className="mainTable">
                  {roleLoading ? (
                    <p>Fetching users...</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                        <thead style={{ whiteSpace: 'nowrap' }}>
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            {/* <th>Role</th>
                    <th>User Type</th> */}
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody style={{ whiteSpace: 'nowrap' }}>
                          {tableData.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>
                              <td>{item.email}</td>
                              <td>{item.phone_number}</td>
                              {/* <td>{item.roles?.map((role, index) => <span key={index}>{role.name}</span>)}</td> */}
                              <td>
                                <div onClick={() => handleEyeClick(item.id)} className="btn btn-success-soft btn-sm mr-1">
                                  <i className="far fa-eye" style={{ color: "#008a4b", backgroundColor: "#28a7451a", padding: 2, borderColor: "#28a7454d", borderRadius: 5, fontSize: 12 }}></i>
                                </div>
                                <div onClick={() => handleTrashClick(item.id)} className="btn btn-danger-soft btn-sm">
                                  <i className="far fa-trash-alt" style={{ color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12 }}></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className={classes.space1b} />
                <div className="d-flex justify-content-between align-items-center">
                  <p>Showing {startIndexx} to {endIndexx} of {totalEntries} entries</p>
                  <div className="d-flex">
                    <button
                      style={{ border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginRight: 10, cursor: "pointer" }}
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    {[...Array(totalPages)].map((_, page) => {
                      if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                        return (
                          <button
                            key={page + 1}
                            style={{
                              marginLeft: '0.4rem',
                              marginRight: '0.4rem',
                              fontSize: '14px',
                              fontFamily: 'nunito',
                              fontWeight: 400,
                              color: page + 1 === currentPage ? '#ffffff' : '#000',
                              backgroundColor: page + 1 === currentPage ? '#28a745' : 'gainsboro',
                              height: '2.5rem',
                              borderRadius: '89px',
                              padding: '0.5rem',
                              border: 'none',
                              width: '40px',
                              cursor: "pointer"
                            }}
                            onClick={() => setCurrentPage(page + 1)}
                          >
                            {page + 1}
                          </button>
                        );
                      }
                      return null;
                    })}
                    <button
                      style={{ cursor: "pointer", border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginLeft: 10 }}
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </Modal.Body>

            </Modal>

            <Modal show={show3} onHide={handleClose3} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Loan Types</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form style={{ marginBottom: 20 }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                        <Form.Label>Loan Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Loan Code"
                          value={loanCode}
                          onChange={(e) => setLoanCode(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Description"
                          value={loanDescription}
                          onChange={(e) => setLoanDescription(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>Loan Interest</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Loan Interest"
                          value={interest} onChange={(e) => setInterest(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>Balance</Form.Label>
                        <CurrencyInput

                          name="balance"
                          decimalsLimit={2}
                          className="form-control"
                          value={balance} // Set the value to the balance state
                          onValueChange={handleValueChange}
                          style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>A/C Receivables</Form.Label>
                        <Select loading={isLoading} dropdownHeight='100px' options={accRec} style={{ borderRadius: 5, width: '100%', marginLeft: -3 }}
                          onChange={setSelectedReportTo} value={selectedReportTo} placeholder="Select Account Receivables"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>A/C Payables</Form.Label>
                        <Select loading={isLoading} dropdownHeight='100px' options={accPay} style={{ borderRadius: 5, width: '100%', marginLeft: -3 }}
                          onChange={setSelectedPayables} value={selectedPayables} placeholder="Select Account Payables"
                        />
                      </Form.Group>
                    </div>
                  </div>

                </Form>
                <Modal.Footer>

                  {isUpdateMode && (
                    <Button variant="danger" onClick={clearForm}>
                      Clear Form
                    </Button>
                  )}
                  <Button variant="success" onClick={handleSubmit1}>
                    {loanLoading ? (
                      <>
                        <Spinner size='sm' />
                        <span style={{ marginLeft: '5px' }}>{isUpdateMode ? "Updating, Please wait..." : "Saving, Please wait..."}</span>
                      </>
                    ) : (
                      isUpdateMode ? 'Update' : 'Save')}
                  </Button>

                </Modal.Footer>


                <div className="d-flex justify-content-between align-items-center" style={{ padding: '20px 0 0 0', marginBottom: 20 }}>

                </div>
                {/* <div className="text-right modal-effect">
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <div className="d-flex justify-content-start align-items-center">
              <div className="mr-2">Search:</div>
              <input
                type="search"
                value={searchTerm}
                className="form-control form-control-sm"
                aria-controls="DataTables_Table_0"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button style={{ marginLeft: 10 }} variant="success" onClick={() => fetchSearch(searchTerm)}>
                {searchLoading ? <Spinner size="sm" /> : "Search"}
              </Button>
            </div>
          </div>
        </div> */}
                <div className={classes.spaceb} />
                <div className="mainTable">
                  {staffLoading ? (
                    <p>Fetching data...</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                        <thead style={{ whiteSpace: 'nowrap' }}>
                          <tr>
                            <th>S/N</th>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Interest Rate</th>
                            <th>Opening Balance</th>
                            <th>Report To</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody style={{ whiteSpace: 'nowrap' }}>
                          {staffLoan.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td style={{ textAlign: "left" }}>{item.code}</td>
                              <td>{item.description}</td>
                              <td style={{ textAlign: "left" }}>{item.interest}</td>
                              <td style={{ textAlign: "right" }}>{parseFloat(item.opening_balance).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}</td>
                              <td>{item.report?.gl_name}</td>
                              <td>
                                {/* {(isAdmin || permittedHeaders.includes('update-loan-account')) && ( */}
                                <div onClick={() => handleEyeClick1(item.id)} className="btn btn-success-soft btn-sm mr-1">
                                  <i className="far fa-eye" style={{ color: "#008a4b", backgroundColor: "#28a7451a", padding: 2, borderColor: "#28a7454d", borderRadius: 5, fontSize: 12 }}></i>
                                </div>
                                {/* )} */}
                                {/* {(isAdmin || permittedHeaders.includes('delete-loan-account')) && ( */}
                                <div className="btn btn-danger-soft btn-sm">
                                  <i className="far fa-trash-alt" style={{ color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12 }}></i>
                                </div>
                                {/* )} */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className={classes.space1b} />
                <div className="d-flex justify-content-between align-items-center">
                  <p>Showing {startIndexx} to {endIndexx} of {totalEntries} entries</p>
                  <div className="d-flex">
                    <button
                      style={{ border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginRight: 10, cursor: "pointer" }}
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    {[...Array(totalPages)].map((_, page) => {
                      if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                        return (
                          <button
                            key={page + 1}
                            style={{
                              marginLeft: '0.4rem',
                              marginRight: '0.4rem',
                              fontSize: '14px',
                              fontFamily: 'nunito',
                              fontWeight: 400,
                              color: page + 1 === currentPage ? '#ffffff' : '#000',
                              backgroundColor: page + 1 === currentPage ? '#28a745' : 'gainsboro',
                              height: '2.5rem',
                              borderRadius: '89px',
                              padding: '0.5rem',
                              border: 'none',
                              width: '40px',
                              cursor: "pointer"
                            }}
                            onClick={() => setCurrentPage(page + 1)}
                          >
                            {page + 1}
                          </button>
                        );
                      }
                      return null;
                    })}
                    <button
                      style={{ cursor: "pointer", border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginLeft: 10 }}
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </Modal.Body>
              {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary">
          Save Changes
        </Button>
      </Modal.Footer> */}
            </Modal>
            <Modal show={show1} onHide={handleClose1} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>User Modules</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form style={{ marginBottom: 20 }}>
                  <Form.Label>User</Form.Label>
                  <Form.Select name="user" className="form-control" required="" value={selectedUser} onChange={handleUserChange}>
                    <option value="">Select User</option>
                    {tableData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form>
                <div className='modal-footer' style={{ marginTop: 20 }} />
                <div style={{ display: "flex", gap: 5 }}>
                  <ToggleSlider disabled={isLoading} checked={checkAll} onChange={handleCheckAllToggle} />
                  <p>Check All</p>


                </div>
                <div className='modal-footer' style={{ marginTop: 20 }} />
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                  {isLoading ? (
                    <>
                      <Spinner size='sm' animation="border" role="status" />

                    </>
                  ) : (
                    <>
                      {permissions?.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            width: '130px',
                            height: '130px',
                            margin: '5px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                            boxSizing: 'border-box', // Include padding and border in the width
                            marginBottom: 20,
                            overflow: 'hidden'
                          }}
                        >
                          <ToggleSlider
                            checked={toggleStates[item.id]}
                            onChange={() => handleToggleChange(item.id)}
                          />
                          <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.module?.name}</p>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleClose1}>
                  Close
                </Button>
                <Button variant="success" className={classes.btn2} onClick={createModule}>
                  {moduleLoading ? (
                    <>
                      <Spinner size='sm' />
                      <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                    </>
                  ) : (
                    "Assign User Module"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={show4} onHide={handleClose4} size="lg" centered>
              <Modal.Header closeButton className="justify-content-center">
                <Modal.Title className="w-100 text-center">Welcome to Account Reconciliation Setup</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ height: "55%" }}>
                <Form style={{ marginBottom: 20, padding: "0 50px" }}>
                  <div style={{
                    border: '1px solid #ccc',
                    borderRadius: '10px',
                    padding: '20px',
                    position: 'relative',
                    marginTop: '20px'
                  }}>
                    <legend style={{
                      color: 'green',
                      // fontWeight: 'bold',
                      fontSize: '14px',
                      position: 'absolute',
                      top: '-12px',
                      left: '20px',
                      backgroundColor: 'white',
                      width: "140px",
                      padding: '0 10px'
                    }}>
                      Select Option
                    </legend>
                    <Row >
                      <Col xs={4} md={4} onClick={handleShow5}>
                        <Card className={`${classes.hoverShadowCard}`} border="primary" style={{ width: '20rem', }}>
                          {/* <Card.Header>⚙️</Card.Header> */}
                          <Card.Body>
                            <h2 style={{ color: "#00009bff" }}>⚙</h2>
                            <p><i class="bi bi-gear" style={{ color: "blue", fontSize: "24px" }}></i></p>
                            <Card.Title>Setup New Account</Card.Title>
                            <Card.Text>
                              Upload Outstanding Cashbook, Outstanding Bank Statement
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xs={4} md={4} onClick={handleShow8} style={{ marginLeft: '8rem' }}>
                        <Card className={`${classes.hoverShadowCard2}`} border="primary" style={{ width: '18rem', backgroundColor: "#AAFFC91A", border: "1px solid #16A34A" }}>
                          {/* <Card.Header>⚙️</Card.Header> */}
                          <Card.Body>
                            <h2 style={{ color: "#00009bff" }}>♻️</h2>
                            <p><i class="bi bi-gear" style={{ color: "blue", fontSize: "24px" }}></i></p>
                            <Card.Title>Monthly Reconciliation</Card.Title>
                            <Card.Text>
                              Import Cashbook, Upload Account Statement
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      {/* <Col xs={4} md={4} onClick={handleShow7}>
                          <Card className={`${classes.hoverShadowCard2}`} style={{ width: '12rem', backgroundColor: "#AAFFC91A", border: "1px solid #16A34A" }}>
                           
                            <Card.Body>
                              <h2>♻️</h2>
                              <Card.Title>Reconcile an Account</Card.Title>
                              <Card.Text>
                                Reconcile Accoount, Generate Reconcilation Summary Report, etc
                              </Card.Text>
                            </Card.Body>
                          </Card>                    
                        </Col> */}
                    </Row>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>

            <Modal show={show5} onHide={handleClose5} size="md" centered>
              <Modal.Header closeButton>
                <Modal.Title>Setup Account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label className={classes.formLabelCustom}>Select Account</Form.Label>
                    <Select
                      className={classes.formControl}
                      options={opt}
                      placeholder="Select Account"
                      onChange={handleAccountChange}
                      menuPortalTarget={document.body}
                      styles={{
                        width: "100%",
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: '300px',
                          overflowY: 'auto',

                        }),
                      }}
                    />

                    <Row style={{ margin: "10px 0 0 0", padding: 0 }}>
                      <Col md={4} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check1"
                          label="Normal Account"
                          className={classes.customCheckbox} // optional custom style
                        // checked={agreed}
                        // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                      <Col md={8} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check2"
                          label="Suspense Account"
                          className={classes.customCheckbox} // optional custom style
                        // checked={agreed}
                        // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                      <Col md={12} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check3"
                          label="Zero Balance with Outstanding Items"
                          className={classes.customCheckbox} // optional custom style
                        // checked={agreed}
                        // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                    </Row>
                    <div style={{
                      border: '1px solid #ccc',
                      borderRadius: '10px',
                      padding: '20px',
                      position: 'relative',
                      marginTop: '20px'
                    }}>
                      <legend style={{
                        color: 'green',
                        // fontWeight: 'bold',
                        fontSize: '14px',
                        position: 'absolute',
                        top: '-12px',
                        left: '20px',
                        backgroundColor: 'white',
                        width: "140px",
                        padding: '0 10px'
                      }}>
                        Lodger Balance
                      </legend>
                      <Row style={{ marginTop: 10 }}>
                        <Col md={5}>
                          <Form.Label>Cashbook Date:</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder=""
                            // autoFocus
                            value={selectedDates}
                            onChange={handleDateSelected}
                          // onBlur={uploadStatement2}
                          />
                        </Col>
                        <Col md={7}>
                          <Form.Label>Cashbook Balance:</Form.Label>
                          <Form.Control
                            disabled
                            type="text"
                            placeholder="Cashbook Balance"
                            value={
                              !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : ''
                            }
                            onChange={(e) => setCashBalance(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 15 }}>
                        <Col md={5}>
                          <Form.Label>Statement Date:</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder=""
                            // autoFocus
                            value={selectedDate2}
                            onChange={(e) => setSelectedDate2(e.target.value)}
                          // onBlur={uploadStatement2}
                          />
                        </Col>
                        <Col md={7}>
                          <Form.Label>Statement Balance</Form.Label>
                          <CurrencyInput
                            name="statementBalance"
                            value={statementBalance}
                            decimalsLimit={2}
                            groupSeparator=","
                            onValueChange={(value) => setStatementBalance(value)}
                            placeholder="Statement Balance"
                            className="form-control"
                          />
                        </Col>
                      </Row>
                      {/* <Row style={{ marginTop: 10 }}>
                      <Col md={5}>
                        <Row>
                          <Col md={3} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Date:</Form.Label>
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              type="date"
                              placeholder=""
                              // autoFocus
                              value={selectedDate}
                              onChange={(e) => setSelectedDate(e.target.value)}
                              onBlur={uploadStatement2}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={7}>
                        <Row>
                          <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Cashbook Bal:</Form.Label>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              disabled
                              type="text"
                              placeholder="Cashbook Balance"
                              value={
                                !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                  ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : ''
                              }
                              onChange={(e) => setCashBalance(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                      <Col md={5}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                          <Form.Label>Date:</Form.Label>
                        </Col>
                        <Col md={9}>
                          <Form.Control
                            type="date"
                            placeholder=""
                            // autoFocus
                            value={selectedDate2}
                            onChange={(e) => setSelectedDate2(e.target.value)}
                            // onBlur={uploadStatement2}
                          />
                        </Col>
                      </Row>
                      </Col>
                      <Col md={7}>
                      <Row>
                        <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                          <Form.Label>Statement Bal:</Form.Label>
                        </Col>
                        <Col md={7}>
                          <CurrencyInput
                            name="statementBalance"
                            value={statementBalance}
                            decimalsLimit={2}
                            groupSeparator=","
                            onValueChange={(value) => setStatementBalance(value)}
                            placeholder="Statement Balance"
                            className="form-control"
                          />
                        </Col>
                      </Row>
                      </Col>
                    </Row> */}
                    </div>

                  </Form.Group>
                </Form>
              </Modal.Body>

              {/* <Modal.Footer className="d-flex justify-content-center"> */}
              <Modal.Footer>
                <Button onClick={handleShow4} style={{
                  backgroundColor: 'white',
                  border: '1px solid #212121ff',
                  color: '#212121ff'
                }}>
                  Go back
                </Button>
                <Button variant="success" onClick={handleShow2}>
                  Save ⊕
                </Button>
              </Modal.Footer>

            </Modal>

            <Modal show={show8} onHide={handleClose8} size="md" centered>
              <Modal.Header closeButton>
                <Modal.Title>Process Monthly Reconciliation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label className={classes.formLabelCustom}>Select Account</Form.Label>
                    <Select
                      className={classes.formControl}
                      options={optProcess}
                      placeholder="Select Account"
                      onChange={handleAccountChangeProcess}
                      menuPortalTarget={document.body}
                      styles={{
                        width: "100%",
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: '300px',
                          overflowY: 'auto',

                        }),
                      }}
                    />
                    <Col md={12}>
                      <div style={{ marginTop: 15 }} />
                      <Form.Label>Current Date:</Form.Label>
                      <Form.Control
                        type="text"
                        // autoFocus
                        value={
                          fixedDate2
                            ? formatDateToLastOfMonth(fixedDate2)
                            : "Select an account"
                        }
                        // value={selectedDate}
                        disabled
                      // onChange={(e) => setSelectedDate(e.target.value)}
                      // max={fixedDate2 || undefined}
                      />
                    </Col>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }} />
                        <Form.Label>Cashbook Last Date:</Form.Label>
                        <Form.Control
                          type="date"
                          // autoFocus
                          value={fixedDate2}
                          // value={selectedDate}
                          disabled
                          onChange={(e) => setSelectedDate(e.target.value)}
                        // max={fixedDate2 || undefined}
                        />
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }} />
                        <Form.Label>Statement Last Date:</Form.Label>
                        <Form.Control
                          type="date"
                          disabled
                          // autoFocus
                          value={fixedDate}
                          // value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                        // max={fixedDate || undefined}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }} />
                        <Form.Label>Cashbook Balance:</Form.Label>
                        <Form.Control
                          type="text"
                          // autoFocus
                          style={{ textAlign: 'right' }}
                          value={cashbookOpening ?
                            formatCurrency(cashbookOpening) : 'Select an Account'
                          }
                          // value={selectedDate}
                          disabled
                        // onChange={(e) => setSelectedDate(e.target.value)}
                        // max={fixedDate2 || undefined}
                        />
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }} />
                        <Form.Label>Statement Balance:</Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          style={{ textAlign: 'right' }}
                          // autoFocus
                          value={statementOpening ?
                            formatCurrency(statementOpening) : 'Select an Account'
                          }
                        // value={selectedDate}
                        // onChange={(e) => setSelectedDate(e.target.value)}
                        // max={fixedDate || undefined}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Form>
              </Modal.Body>

              {/* <Modal.Footer className="d-flex justify-content-center"> */}
              <Modal.Footer>
                <Button onClick={handleShow4} style={{
                  backgroundColor: 'white',
                  border: '1px solid #212121ff',
                  color: '#212121ff'
                }}>
                  Go back
                </Button>
                <Button variant="success" onClick={pullCashbook}>
                  Continue ⊕
                </Button>
              </Modal.Footer>

            </Modal>

            <Modal show={show7} onHide={handleClose7} size="md" centered>
              <Modal.Header closeButton>
                <Modal.Title>Select Reconciliation Account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label className={classes.formLabelCustom}>Select Account</Form.Label>
                    <Select
                      className={classes.formControl}
                      options={opt2}
                      placeholder="Select Account"
                      onChange={handleAccountChange2}
                      menuPortalTarget={document.body}
                      styles={{
                        width: "100%",
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: '100px',
                          overflowY: 'auto',

                        }),
                      }}
                    />
                    {/* <Row style={{ margin: "10px 0 0 0", padding: 0 }}>
                      <Col md={4} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check1"
                          label="Normal Account"
                          className={classes.customCheckbox} // optional custom style
                          // checked={agreed}
                          // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                      <Col md={8} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check2"
                          label="Suspense Account"
                          className={classes.customCheckbox} // optional custom style
                          // checked={agreed}
                          // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                      <Col md={12} style={{ padding: 0 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check3"
                          label="Zero Balance with Outstanding Items"
                          className={classes.customCheckbox} // optional custom style
                          // checked={agreed}
                          // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                    </Row> */}

                    <div style={{ marginTop: 15 }} />
                    <Form.Label>Select Date:</Form.Label>
                    <Form.Control
                      type="date"
                      // autoFocus
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      max={fixedDate || undefined}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={handleShow4} style={{
                  backgroundColor: 'white',
                  border: '1px solid #212121ff',
                  color: '#212121ff'
                }}>
                  Go back
                </Button>
                <Button variant="success" onClick={handleReconcilePage2}>
                  Next
                </Button>
              </Modal.Footer>

            </Modal>

            <Modal show={show2} onHide={handleClose2} size="lg" centered dialogClassName={classes.customModalWidth}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Cashbook</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <Form> */}
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Opening Balance:</Form.Label>
                        <Form.Control
                          type="text"
                          value={
                            !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                              ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : ''
                          }
                          onChange={(e) => setCashBalance(e.target.value)}
                          name="total"
                          disabled
                          style={{ textAlign: 'right' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                    </Col>
                    {/* <Col md={6}>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Opening Balance:</Form.Label>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type="text"
                              value={
                                !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                  ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : ''
                              }
                              onChange={(e) => setCashBalance(e.target.value)}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col> */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <a
                            href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
                            download
                            style={{ margin: "0 0 20px 0" }}
                          >
                            <b
                              className={classes.btn1}
                              style={{ height: "35px", fontSize: "12px", borderRadius: 5 }}
                              variant="success"
                            >
                              Download Template
                            </b>
                          </a>
                        </Form.Label>
                        <Form.Control
                          type="file"
                          placeholder="Choose file"
                          accept=".xlsx"
                          // onChange={handleImageChange}
                          // onBlur={uploadStatement3}
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              handleImageChange(event);
                              uploadStatement3(file);
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className={`row ${classes.awrow1}`}>
                    <div className={classes.mainTable}>
                      <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', }}>
                        <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                          <thead style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                            <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Post Date</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Val Date</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px" }}>Description</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Debit</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Credit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {createLoading ? (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                  Loading balances...
                                </td>
                              </tr>
                            ) : currentRows.length > 0 ? (
                              currentRows.map((item, index) => (
                                <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.post_date}</td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.val_date}</td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.description}</td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>
                                    {parseFloat(item.debit).toLocaleString("en-US", {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>
                                    {parseFloat(item.credit).toLocaleString("en-US", {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                  No balances available
                                </td>
                              </tr>
                            )}
                            {/* {currentRows.map((item, index) => (
                                <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.post_date}</td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.val_date}</td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{item.description}</td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>
                                    {parseFloat(item.debit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>
                                    {parseFloat(item.credit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                </tr>
                              ))} */}
                          </tbody>
                        </table>
                        {/* Pagination Controls */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            <button
                              className="btn btn-sm btn-light me-2"
                              onClick={() => setCurrentPage2(prev => Math.max(prev - 1, 1))}
                              disabled={currentPage2 === 1}
                            >
                              Previous
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => setCurrentPage2(prev => Math.min(prev + 1, totalPages2))}
                              disabled={currentPage2 === totalPages2}
                            >
                              Next
                            </button>
                          </div>

                          <div>
                            <span>Page {currentPage2} of {totalPages2}</span>
                          </div>

                          <div>
                            <label className="me-2">Rows per page:</label>
                            <select
                              className="form-select form-select-sm"
                              value={rowsPerPage}
                              onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage2(1); // reset to first page
                              }}
                              style={{ width: "auto", display: "inline-block" }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={75}>75</option>
                              <option value={100}>100</option>
                            </select>
                          </div>
                        </div>
                        {/* <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                            <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                              <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px"}}>Post Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px"}}>Val Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px"}}>Description</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px"}}>Debit</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px"}}>Credit</th>
                              </tr>
                            </thead>

                            <tbody>
                              {balances.map((item, index) => (
                                <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.post_date}
                                  </td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.val_date}
                                  </td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.description}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                </tr>
                              ))}
                              </tbody>
                          </table> */}
                      </div>
                      <div style={{ marginTop: "15px" }} />
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Closing Balance:</Form.Label>
                            <Form.Control
                              type="text"
                              value={closingBalance}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2}>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Credit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountCredit}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Debit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountDebit}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>

                  </div>
                </Form.Group>
                {/* </Form> */}
                <Row>
                  <Col md={8}>
                  </Col>
                  <Col md={4} style={{ textAlign: "right", gap: "15px", }}>
                    <Button onClick={handleShow5} style={{
                      backgroundColor: 'white',
                      border: '1px solid #212121ff',
                      color: '#212121ff',
                      margin: "0 10px 0 0"
                    }}>
                      Go back
                    </Button>
                    <Button
                      className={classes.longbtn}
                      variant='success'
                      onClick={handleShow6}
                      style={{ padding: '5px 30px' }}>
                      Update
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between w-100">
                <div className="d-flex">
                  <p className="mb-0 me-4">Total Debit Count: {totalDebitCount}</p>
                  <p className="mb-0">Total Credit Count: {totalCreditCount}</p>
                </div>
                <p className="mb-0" style={{ color: "#c90404", cursor: "pointer" }} onClick={handleShow6}>Skip</p>
              </Modal.Footer>
            </Modal>

            <Modal show={show2Process} onHide={handleClose2Process} size="lg" centered dialogClassName={classes.customModalWidth}>
              <Modal.Header closeButton>
                <Modal.Title>Import Cashbook</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <Form> */}
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  {/* <Row>
                      <Col md={12} style={{ paddingLeft: 10, paddingBottom: 10 }}>
                        <Form.Check
                          type="checkbox"
                          id="custom-check3"
                          label="Import Cashbook"
                          className={classes.customCheckbox} // optional custom style
                          // checked={agreed}
                          // onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Col>
                    </Row> */}
                  <div className={`row ${classes.awrow1}`}>
                    <div className={classes.mainTable}>
                      <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', }}>
                        <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                          <thead style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                            <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Post Date</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Val Date</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px" }}>Description</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Debit</th>
                              <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Credit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {createLoading ? (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                  Loading balances...
                                </td>
                              </tr>
                            ) : currentRows.length > 0 ? (
                              currentRows.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.transaction_date}</td>
                                  <td >{item.val_date}</td>
                                  <td >{item.details}</td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>
                                    {item.crdr == 2
                                      ? parseFloat(item.amount).toLocaleString("en-US", {
                                        minimumIntegerDigits: 1,
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                      : "0.00"}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>
                                    {item.crdr == 1
                                      ? parseFloat(item.amount).toLocaleString("en-US", {
                                        minimumIntegerDigits: 1,
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                      : "0.00"}
                                  </td>
                                  {/* <td style={{ textAlign: "right", paddingRight: 10 }}>
                                        {parseFloat(item.credit).toLocaleString("en-US", {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}
                                      </td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                  No balances available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {/* Pagination Controls */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            <button
                              className="btn btn-sm btn-light me-2"
                              onClick={() => setCurrentPage2(prev => Math.max(prev - 1, 1))}
                              disabled={currentPage2 === 1}
                            >
                              Previous
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => setCurrentPage2(prev => Math.min(prev + 1, totalPages2))}
                              disabled={currentPage2 === totalPages2}
                            >
                              Next
                            </button>
                          </div>

                          <div>
                            <span>Page {currentPage2} of {totalPages2}</span>
                          </div>

                          <div>
                            <label className="me-2">Rows per page:</label>
                            <select
                              className="form-select form-select-sm"
                              value={rowsPerPage}
                              onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage2(1); // reset to first page
                              }}
                              style={{ width: "auto", display: "inline-block" }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={75}>75</option>
                              <option value={100}>100</option>
                            </select>
                          </div>
                        </div>
                        {/* <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                            <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                              <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px"}}>Post Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px"}}>Val Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px"}}>Description</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px"}}>Debit</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px"}}>Credit</th>
                              </tr>
                            </thead>

                            <tbody>
                              {balances.map((item, index) => (
                                <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.post_date}
                                  </td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.val_date}
                                  </td>
                                  <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    {item.description}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                </tr>
                              ))}
                              </tbody>
                          </table> */}
                      </div>
                      <div style={{ marginTop: "15px" }} />
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Closing Balance:</Form.Label>
                            <Form.Control
                              type="text"
                              value={closingBalance}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2}>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Credit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountCredit}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Debit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountDebit}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>

                  </div>
                </Form.Group>
                {/* </Form> */}
                <Row>
                  <Col md={8}>
                  </Col>
                  <Col md={4} style={{ textAlign: "right", gap: "15px", }}>
                    <Button onClick={handleShow5Process} style={{
                      backgroundColor: 'white',
                      border: '1px solid #212121ff',
                      color: '#212121ff',
                      margin: "0 10px 0 0"
                    }}>
                      Go back
                    </Button>
                    <Button
                      className={classes.longbtn}
                      variant='success'
                      onClick={handleShow6Process}
                      style={{ padding: '5px 30px' }}>
                      Update
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between w-100">
                <div className="d-flex">
                  <p className="mb-0 me-4">Total Debit Count: {totalDebitCount}</p>
                  <p className="mb-0">Total Credit Count: {totalCreditCount}</p>
                </div>
                <p className="mb-0" style={{ color: "#c90404", cursor: "pointer" }} onClick={handleShow6}>Skip</p>
              </Modal.Footer>
            </Modal>

            <Modal show={show6} onHide={handleClose6} size="lg" centered dialogClassName={classes.customModalWidth}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Statement of Account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Opening Balance:</Form.Label>
                          <Form.Control
                            type="text"
                            value={
                              !isNaN(parseFloat(statementBalance)) && statementBalance !== ''
                                ? parseFloat(statementBalance).toLocaleString('en-NG', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : ''
                            }
                            onChange={(e) => setStatementBalance(e.target.value)}
                            name="total"
                            disabled
                            style={{ textAlign: 'right' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                      </Col>
                      {/* <Col md={6}>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Opening Balance:</Form.Label>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type="text"
                              value={
                                !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                  ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : ''
                              }
                              onChange={(e) => setCashBalance(e.target.value)}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col> */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <a
                              href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
                              download
                              style={{ margin: "0 0 20px 0" }}
                            >
                              <b
                                className={classes.btn1}
                                style={{ height: "35px", fontSize: "12px", borderRadius: 5 }}
                                variant="success"
                              >
                                Download Template
                              </b>
                            </a>
                          </Form.Label>
                          <Form.Control
                            type="file"
                            placeholder="Choose file"
                            accept=".xlsx"
                            // onChange={handleImageChange}
                            // onBlur={uploadStatement3}
                            onChange={(event) => {
                              const file = event.target.files[0];
                              if (file) {
                                handleImageChange2(event);     // Save the file to state
                                uploadStatement4(file);        // Immediately trigger API call
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className={`row ${classes.awrow1}`}>
                      <div className={classes.mainTable}>
                        <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', }}>
                          <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                            <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                              <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Post Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Val Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px" }}>Description</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Debit</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Credit</th>
                              </tr>
                            </thead>

                            <tbody>
                              {createLoading2 ? (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                    Loading statement balances...
                                  </td>
                                </tr>
                              ) : balances2.length > 0 ? (
                                balances2.map((item, index) => (
                                  <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.post_date}
                                    </td>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.val_date}
                                    </td>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.description}
                                    </td>
                                    <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                    </td>
                                    <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                    No balances available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div style={{ marginTop: "15px" }} />
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Closing Balance:</Form.Label>
                              <Form.Control
                                type="text"
                                value={closingBalance2}
                                name="total"
                                disabled
                                style={{ textAlign: 'right' }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                  <Form.Label>Total Credit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="total"
                                    value={totalAmountCredit2}
                                    disabled
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                  <Form.Label>Total Debit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="total"
                                    value={totalAmountDebit2}
                                    disabled
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>

                    </div>
                  </Form.Group>
                </Form>
                <Row>
                  <Col md={8}>
                  </Col>
                  <Col md={4} style={{ textAlign: "right", gap: "15px" }}>
                    <Button onClick={handleShow2} style={{
                      backgroundColor: 'white',
                      border: '1px solid #212121ff',
                      color: '#212121ff',
                      margin: "0 10px 0 0"
                    }}>
                      Go back
                    </Button>
                    <Button
                      className={classes.longbtn}
                      variant='success'
                      onClick={postBalances2}
                      disabled={balanceLoading}
                      style={{ padding: '5px 30px' }}>
                      {balanceLoading ? (
                        <>
                          <Spinner size='sm' />
                          <span style={{ marginLeft: '5px' }}>Saving...</span>
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between w-100">
                <div className="d-flex">
                  <p className="mb-0 me-4">Total Debit Count: {totalDebitCount2}</p>
                  <p className="mb-0">Total Credit Count: {totalCreditCount2}</p>
                </div>
                {/* <p className="mb-0" style={{ color: "#c90404", cursor: "pointer" }} onClick={handleShow6}>Skip</p> */}
              </Modal.Footer>
            </Modal>

            <Modal show={show6Process} onHide={handleClose6Process} size="lg" centered dialogClassName={classes.customModalWidth}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Statement of Account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Opening Balance:</Form.Label>
                          <Form.Control
                            type="text"
                            value={
                              !isNaN(parseFloat(statementBalance)) && statementBalance !== ''
                                ? parseFloat(statementBalance).toLocaleString('en-NG', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : ''
                            }
                            onChange={(e) => setStatementBalance(e.target.value)}
                            name="total"
                            disabled
                            style={{ textAlign: 'right' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                      </Col>
                      {/* <Col md={6}>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Opening Balance:</Form.Label>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type="text"
                              value={
                                !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                  ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : ''
                              }
                              onChange={(e) => setCashBalance(e.target.value)}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col> */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <a
                              href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
                              download
                              style={{ margin: "0 0 20px 0" }}
                            >
                              <b
                                className={classes.btn1}
                                style={{ height: "35px", fontSize: "12px", borderRadius: 5 }}
                                variant="success"
                              >
                                Download Template
                              </b>
                            </a>
                          </Form.Label>
                          <Form.Control
                            type="file"
                            placeholder="Choose file"
                            accept=".xlsx"
                            // onChange={handleImageChange}
                            // onBlur={uploadStatement3}
                            onChange={(event) => {
                              const file = event.target.files[0];
                              if (file) {
                                handleImageChange2(event);     // Save the file to state
                                uploadStatement4Process(file);        // Immediately trigger API call
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className={`row ${classes.awrow1}`}>
                      <div className={classes.mainTable}>
                        <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', }}>
                          <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                            <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                              <tr style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Post Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "12%", padding: "2px 10px", margin: "2px 10px" }}>Val Date</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, width: "46%", padding: "2px 10px", margin: "2px 10px" }}>Description</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Debit</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, textAlign: "right", width: "15%", padding: "2px 10px", margin: "2px 10px" }}>Credit</th>
                              </tr>
                            </thead>

                            <tbody>
                              {createLoading2 ? (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                    Loading statement balances...
                                  </td>
                                </tr>
                              ) : balances2.length > 0 ? (
                                balances2.map((item, index) => (
                                  <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.post_date}
                                    </td>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.val_date}
                                    </td>
                                    <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                                      {item.description}
                                    </td>
                                    <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                    </td>
                                    <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                      minimumIntegerDigits: 1,
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "center", padding: "10px" }}>
                                    No balances available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div style={{ marginTop: "15px" }} />
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Closing Balance:</Form.Label>
                              <Form.Control
                                type="text"
                                value={closingBalance2}
                                name="total"
                                disabled
                                style={{ textAlign: 'right' }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                  <Form.Label>Total Credit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="total"
                                    value={totalAmountCredit2}
                                    disabled
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                  <Form.Label>Total Debit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="total"
                                    value={totalAmountDebit2}
                                    disabled
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>

                    </div>
                  </Form.Group>
                </Form>
                <Row>
                  <Col md={8}>
                  </Col>
                  <Col md={4} style={{ textAlign: "right", gap: "15px" }}>
                    <Button onClick={handleShow2Process} style={{
                      backgroundColor: 'white',
                      border: '1px solid #212121ff',
                      color: '#212121ff',
                      margin: "0 10px 0 0"
                    }}>
                      Go back
                    </Button>
                    <Button
                      className={classes.longbtn}
                      variant='success'
                      onClick={postBalances2Process}
                      disabled={balanceLoading}
                      style={{ padding: '5px 30px' }}>
                      {balanceLoading ? (
                        <>
                          <Spinner size='sm' />
                          <span style={{ marginLeft: '5px' }}>Saving...</span>
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between w-100">
                <div className="d-flex">
                  <p className="mb-0 me-4">Total Debit Count: {totalDebitCount2}</p>
                  <p className="mb-0">Total Credit Count: {totalCreditCount2}</p>
                </div>
                {/* <p className="mb-0" style={{ color: "#c90404", cursor: "pointer" }} onClick={handleShow6}>Skip</p> */}
              </Modal.Footer>
            </Modal>

            {/* <Modal show={show6} onHide={handleClose6} animation={false} size="lg" >
              <Modal.Header closeButton>
              <Modal.Title>Upload Statement of Account</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "20px 20px 0 20px"}}>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <a
                      href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
                      download
                      style={{ margin: "0 0 20px 0" }}
                    >
                      <b
                        className={classes.btn1}
                        style={{ height: "35px", fontSize: "12px", borderRadius: 5 }}
                        variant="success"
                      >
                        Download Template
                      </b>
                    </a>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={12}>
                          <Form.Control
                            type="file"
                            placeholder="Choose file"
                            accept=".xlsx"
                              onChange={(event) => {
                              const file = event.target.files[0];
                              if (file) {
                                handleImageChange2(event);     // Save the file to state
                                uploadStatement4(file);        // Immediately trigger API call
                              }
                            }}
                          />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                            <Form.Label>Opening Balance:</Form.Label>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type="text"
                              value={
                                !isNaN(parseFloat(statementBalance)) && statementBalance !== ''
                                  ? parseFloat(statementBalance).toLocaleString('en-NG', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : ''
                              }
                              onChange={(e) => setStatementBalance(e.target.value)}
                              name="total"
                              disabled
                              style={{ textAlign: 'right' }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                    <div className={`row ${classes.awrow1}`}>
                      <div className={classes.mainTable}>
                        <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', }}>
                          <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                            <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                              <tr>
                                <th >Post Date</th>
                                <th >Val Date</th>
                                <th >Description</th>
                                <th style={{ textAlign: "right", width: "50px" }}>Debit</th>
                                <th style={{ textAlign: "right", width: "50px" }}>Credit</th>
                              </tr>
                            </thead>

                            <tbody>
                              {balances2.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {item.post_date}
                                  </td>
                                  <td>
                                    {item.val_date}
                                  </td>
                                  <td>
                                    {item.description}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                  <td style={{ textAlign: "right", paddingRight: 10 }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                  </td>
                                </tr>
                              ))}
                              </tbody>
                          </table>
                        </div>
                      <div style={{ marginTop: "15px" }} />
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Closing Balance:</Form.Label>
                              <Form.Control
                                type="text"
                                value={closingBalance2}
                                name="total"
                                disabled
                                style={{ textAlign: 'right' }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Credit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountCredit2}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                              </Col>
                              <Col md={6}>
                              <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                <Form.Label>Total Debit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="total"
                                  value={totalAmountDebit2}
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
    
                    </div>
                  </Form.Group>
                </Form>
              </Modal.Body>    
              <Modal.Footer style={{ padding: "0 20px 0 20px", borderTop: "none"}}>
                    <Button variant="danger" onClick={handleShow2}>
                      Back
                    </Button>
                    <Button
                      className={classes.longbtn}
                      variant='success'
                      onClick={postBalances2}
                      style={{ padding: '5px 30px' }}>
                      {balanceLoading ? (
                        <>
                          <Spinner size='sm' />
                          <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
              </Modal.Footer>
              <Modal.Footer className="d-flex justify-content-start">
                <p className="mb-0 me-4">Total Debit Count: {totalDebitCount2}</p>
                <p className="mb-0">Total Credit Count: {totalCreditCount2}</p>
              </Modal.Footer>
            </Modal> */}

          </div>
          <div className={classes.moduleSelectorsCont}>
            <div className={classes.moduleSelectors}>
              <div style={{ display: 'flex', justifyContent: "flex-end", width: '100%', marginRight: 40 }}>
                {(admin !== 'Super Admin' && admin !== 'Compliance') && (
                  <>
                    {monthLoading && <Spinner animation="border" />}
                    <NavDropdown style={{ color: 'green', fontWeight: '800' }} title={formattDate(currentMonth)}>
                      <NavDropdown.Item onClick={handleTrashClick1}>Change Working Month</NavDropdown.Item>
                      {/* <NavDropdown.Item onClick={handleTrashClick2}>Reset Working Month</NavDropdown.Item> */}
                    </NavDropdown>
                  </>
                )}
              </div>

              <div className={classes.centerTxt}>
                <p className={classes.headerModuleText}>Choose Your Module</p>
                <p className={classes.moduleText}>Select the module you want to work on.<br />You can only access one assigned module at a time, but you can switch modules whenever needed.</p>

              </div>
              <div className={classes.moduleCont}>
                <ModuleCard
                  moduleName="Accounting"
                  description="Account Receivables, Account Payables, Banking and Cash Management, Accounting reports"
                  icon={<BsCalculator color='#2563EB' size={20} />}
                  color="#DBEAFE"
                  assigned={false} // Changed to false to disable
                  onClick={() => { }} // Empty function to disable click
                />

                <ModuleCard
                  moduleName="Payroll"
                  description="Manage employee records, run monthly payroll, generate payslips, integrate with GL"
                  icon={<PiScrollLight color='#16A34A' size={20} />}
                  color="#AAFFC91A"
                  assigned={false} // Changed to false to disable
                  onClick={() => { }} // Empty function to disable click
                />

                <ModuleCard
                  moduleName="Inventory"
                  description="Stock Management, Sales & Purchase Invoices, etc."
                  icon={<MdOutlineInventory color='#9333EA' size={20} />}
                  color="#F3E8FF"
                  assigned={false} // Changed to false to disable
                  onClick={() => { }} 
                />

                <ModuleCard
                  moduleName="Reconciliation"
                  description="Reconcile Accounts, Generate Reconciliation Summary Report, etc."
                  icon={<AiOutlineReconciliation color='#EA580C' size={20} />}
                  color="#FFEDD5"
                  assigned={false} // Changed to false to disable
                  onClick={() => { }} // Empty function to disable click
                />

                <ModuleCard
                  moduleName="Fixed Asset Management"
                  description="Fixed Assets Register, Asset Disposal, Depreciations, etc."
                  icon={<HiDocumentText color='#DC2626' size={20} />}
                  color="#FEE2E2"
                  // assigned={false} 
                  // Changed to false to disable
                  onClick={() => { }} // Empty function to disable click
                />

                <ModuleCard
                  moduleName="Budgets"
                  description="Upload Budgets, View Performance Reports, etc."
                  icon={<IoNewspaperOutline color='#9333EA' size={20} />}
                  color="#F3E8FF"
                  assigned={permits.includes('Budgets')}
                  onClick={() => handleModuleClick('Budgets')}
                />

               {(admin === 'Super Admin' || userId === "56898") && (
  <ModuleCard
    moduleName="Administration"
    description="Manage Users, Continents, Regions, Provinces, etc."
    icon={<RiAdminLine color='#16A34A' size={20} />}
    color="#AAFFC91A"
    assigned={permits.includes('Administration')}
    onClick={() => handleModuleClick('Administration')}
  />
)}

                <ModuleCard
                  moduleName="Audit"
                  description="Audit Management, View and Generate Audit Reports"
                  icon={<AiOutlineAudit color='#2563EB' size={20} />}
                  color="#DBEAFE"
                  assigned={permits.includes('audit')}
                  onClick={() => handleModuleClick('audit')}
                />
              </div>



            </div>

          </div>




        </div>


      </div>

      {(createLoading || createLoading2) && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
        </div>
      )}

    </div>

  );
}

export default ModuleSelector1;